import { Grid, Stack } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FilterProvider, Filter } from "@/partner/shared/components/Filter";
import { FilterTabs } from "@/partner/shared/components/FilterTabs";
import { LazyAnalyticsWidget } from "@/partner/shared/components/LazyAnalyticsWidget";
import { getAnalyticsTabs } from "./analyticsTabs";
import { AnalyticsSalesMetrics } from "./AnalyticsSalesMetrics";
import { AnalyticsRevenueByDateChart } from "./AnalyticsRevenueByDateChart";
import { AnalyticsSalesByDateChart } from "./AnalyticsSalesByDateChart";
import { AnalyticsSalesByProductTable } from "./AnalyticsSalesByProductTable";
import { AnalyticsSalesByPromocodeTable } from "./AnalyticsSalesByPromocodeTable";
import { AnalyticsSalesByProviderTable } from "./AnalyticsSalesByProviderTable";
import { AnalyticsSalesByCountryMap } from "./AnalyticsSalesByCountryMap";
import { AnalyticsSalesByCountryTable } from "./AnalyticsSalesByCountryTable";
import { AnalyticsSalesByCityTable } from "./AnalyticsSalesByCityTable";
import { AnalyticsSalesByDeviceTypeTable } from "./AnalyticsSalesByDeviceTypeTable";
import { AnalyticsSalesByDeviceOsTable } from "./AnalyticsSalesByDeviceOsTable";
import { AnalyticsSalesByLinkTable } from "./AnalyticsSalesByLinkTable";
import { AnalyticsSalesByEmailCampaignTable } from "./AnalyticsSalesByEmailCampaignTable";
import { AnalyticsSalesByUtmTable } from "./AnalyticsSalesByUtmTable";

function AnalyticsSalesTabContent() {
  const { t } = useTranslation();

  return (
    <Stack spacing={1}>
      <Filter
        title={t("analytics.pageTitle")}
        dateChips="RELATIVE"
        fields={{
          productIds: true,
          promocodeIds: true,
          countryCodes: true,
          currency: true,
          dateFrom: true,
          dateTo: true,
          userDeviceTypes: true,
          userDeviceOss: true,
          linkIds: true,
          utmSources: true,
          utmMediums: true,
          utmCampaigns: true,
          utmContents: true,
          utmTerms: true,
          emailAutomationIds: true,
        }}
      />

      <FilterTabs value="sales" tabs={getAnalyticsTabs(t)} />

      <AnalyticsSalesMetrics />

      <Grid container spacing={1}>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsRevenueByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByDateChart />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByProductTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByPromocodeTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByProviderTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByCountryMap />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByCountryTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByCityTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByDeviceTypeTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByDeviceOsTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByLinkTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByEmailCampaignTable />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByUtmTable
              dimension="SOURCE"
              title={t("analytics.sales.tableByUtmSource")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByUtmTable
              dimension="MEDIUM"
              title={t("analytics.sales.tableByUtmMedium")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByUtmTable
              dimension="CAMPAIGN"
              title={t("analytics.sales.tableByUtmCampaign")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByUtmTable
              dimension="CONTENT"
              title={t("analytics.sales.tableByUtmContent")}
            />
          </LazyAnalyticsWidget>
        </Grid>
        <Grid size={12}>
          <LazyAnalyticsWidget>
            <AnalyticsSalesByUtmTable
              dimension="TERM"
              title={t("analytics.sales.tableByUtmTerm")}
            />
          </LazyAnalyticsWidget>
        </Grid>
      </Grid>
    </Stack>
  );
}

export function AnalyticsSalesTab() {
  return (
    <FilterProvider initialPeriod="month">
      <AnalyticsSalesTabContent />
    </FilterProvider>
  );
}
